import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/data.service";
import { ODataResponse } from '../models/odata-response';
import { AppConfigService } from 'src/app/core/app-config.service';
import { Service } from '../models/service';

@Injectable({
  providedIn: "root",
})
export class ServiceDataService extends DataService<Service> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Services", acs);
  }

  serviceCount(
    serviceId: number,
    code: string
  ) {
    let url = `${this.acs.current.configApiUrl}odata/Services?$filter=Code eq '${code}' and Id ne ${serviceId}&$count=true&$top=0`;
    return this.http.get<ODataResponse<Service>>(url);
  } 
}
